import { useEffect, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { Observable, type Subscriber } from 'rxjs';

export function useResizeObservable<T extends HTMLElement>() {
  const elementRef = useRef<T>(null);
  const [sizeObservable, setSizeObservable] = useState<Observable<ResizeObserverEntry>>(new Observable());

  useEffect(() => {
    if (elementRef.current) {
      setSizeObservable(getSizeObservable(elementRef.current));
    } else {
      console.warn(
        'Undefined element provided to useResizeObservable. Make sure the observed element is rendered while being observed'
      );
    }
  }, [elementRef]);

  return { elementRef, sizeObservable };
}

export function getSizeObservable<T extends HTMLElement>(element: T | null) {
  return new Observable((subscriber: Subscriber<ResizeObserverEntry>) => {
    const observer = new ResizeObserver(([entry]: ResizeObserverEntry[]) => {
      window.requestAnimationFrame(() => {
        if (element) {
          subscriber.next(entry);
        }
      });
    });
    if (element) {
      observer.observe(element);
    } else {
      console.warn(
        'Undefined element provided to getSizeObservable. Make sure the observed element is rendered while being observed'
      );
    }
    return () => observer.disconnect();
  });
}
